// extracted by mini-css-extract-plugin
export default {"motive":"MotiveArea_motive__wKKaf","speech":"MotiveArea_speech__Y+rsy"};